import { render } from "./AddEditTrans.vue?vue&type=template&id=108df820&scoped=true"
import script from "./AddEditTrans.vue?vue&type=script&lang=js"
export * from "./AddEditTrans.vue?vue&type=script&lang=js"

import "./AddEditTrans.vue?vue&type=style&index=0&id=108df820&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-108df820"]])

export default __exports__